import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = {
  key: 1,
  class: "w-full"
}

import { ref, computed, onMounted } from "vue";
import { defineEmits } from "@vue/runtime-core";
import InputCheckbox2 from "./InputCheckbox2.vue";
import { DynamicProperty } from "@/models/dtos";
import InputCheckbox3 from "./InputCheckbox3.vue";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputCheckboxGroup2',
  props: {
  model: {
    type: DynamicProperty,
    required: true,
  },
  placeholder: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const containerByDNS = ref<Profile>(null);

const props = __props;
let model = ref(props.model);

function onChange(e: any) {
  emit("change", e);
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const themedText = computed(() => store.getters.getContainerThemedText);

return (_ctx: any,_cache: any) => {
  return (props.adminView)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(
      _unref(model).key === 'form_agreement' ? 'sm:col-span-full' : 'sm:col-span-1'
    )
      }, [
        _createElementVNode("dt", {
          style: _normalizeStyle({color: themedText.value?.detailText}),
          class: "text-sm font-medium text-gray-500"
        }, _toDisplayString(_unref(model)?.label), 5),
        _createElementVNode("dd", {
          style: _normalizeStyle({color: themedText.value?.otherText}),
          class: "mt-1 text-sm text-gray-900"
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("legend", _hoisted_1, _toDisplayString(_unref(model)?.label), 1),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).data.keys, (item) => {
                return (_openBlock(), _createBlock(InputCheckbox3, {
                  key: item.key,
                  label: item?.label,
                  model: item,
                  id: item?.key,
                  onChange: onChange,
                  "edit-mode": __props.editMode,
                  disabled: !__props.editMode
                }, null, 8, ["label", "model", "id", "edit-mode", "disabled"]))
              }), 128))
            ])
          ])
        ], 4)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("p", {
          style: _normalizeStyle({color: themedText.value?.otherText}),
          class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold"
        }, _toDisplayString(_unref(model).label), 5),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).data.keys, (item, index) => {
          return (_openBlock(), _createBlock(InputCheckbox2, {
            key: index,
            label: item?.label,
            model: item,
            id: item?.key,
            onChange: onChange,
            disabled: __props.disabled
          }, null, 8, ["label", "model", "id", "disabled"]))
        }), 128))
      ]))
}
}

})